var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('AppBar'),_c('v-content',[_c('Content')],1),_c('v-footer',{attrs:{"color":"transparent"}},[_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }